import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { BrandColors } from '../../constants/brandColors';
import { useBasicDetails } from '../../store/storeApi';

export const MobileHelpTooltipStlyes = makeStyles((theme: Theme) => {
  const {
    headerOptions: { selectedTheme },
  } = useBasicDetails();
  return createStyles({
    root: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.primary.dark,
      position: 'fixed',
      top: '0rem',
      width: '100%',
      height: '100%',
      zIndex: 2600,
      textAlign: 'center',
      paddingTop: '7.375rem',
      overflow: 'auto',
      [theme.breakpoints.between('sm', 'md')]: {
        padding: '10rem',
      },
      // [theme.breakpoints.down('sm')]: {
      //   paddingTop: '3rem',
      // },
    },
    compRoot: {
      paddingInline: '2rem',
    },
    compDesc: {
      fontSize: '1.12rem',
      textAlign: 'left',
    },
    headingBox: {
      display: 'grid',
      gridTemplateColumns: 'auto max-content',
    },
    headingText: {
      lineHeight: '3rem',
      fontWeight: 'bold',
      paddingBottom: '1rem',
      letterSpacing: '0.05em',
      fontSize: '1.5rem',
      color: theme.palette.primary.dark,
    },
    closeBtn: {
      position: 'absolute',
      top: '0.625rem',
      right: '0.625rem',
    },
    labelIcon: {
      fontSize: '1.8rem',
      fontWeight: 'bold',
      marginLeft: '-0.45rem',
    },
    listIcon: {
      fontSize: '1.5rem',
      background: theme.palette.background.paper,
      border: `0.125rem solid ${theme.palette.borderColor?.main || BrandColors.transparent}`,
      color: theme.palette.default?.main,
      borderRadius: '0.25rem',
      padding: '0 0.75rem',
      margin: '0.5rem 2rem',
      fontWeight: 'bold',
      display: 'flex',
      width: '2.75rem',
      height: '3rem',
      alignItems: 'center',
    },
    contrastColor: {
      color: theme.palette.primary.dark,
      fontSie: '1.125rem',
      fontWeight: 600,
    },
    displayNone: {
      display: 'none !important',
    },
    closeBtnBox: {
      position: 'relative',
      padding: '3.125rem 0px',
    },
    closeBtn2: {
      borderRadius: '2rem',
      marginLeft: 0,
      fontSize: '0.813rem',
      fontWeight: 'bold',
      width: '6.25rem',
      height: '2.5rem',
      background: selectedTheme === 0 ? theme.palette.background.paper : theme.palette.primary.main,
      color: selectedTheme === 0 ? theme.palette.primary.main : theme.palette.background.paper,
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
  });
});

export const DesktopHelpTooltipStyles = makeStyles((theme: Theme) => {
  const {
    headerOptions: { selectedTheme },
  } = useBasicDetails();
  return createStyles({
    root: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.primary.dark,
      border: '0.125rem solid',
      borderRadius: '0.25rem',
      zIndex: 100,
      position: 'absolute',
      right: '-16rem',
      top: '0.8rem',
      textAlign: 'left',
      width: '15.75rem',
      minWidth: '14.688rem',
      borderColor: theme.palette.borderColor?.main,
      boxShadow: '0.125rem 0.125rem 0.313rem rgb(91 103 112 / 50%)',
      padding: '0.5rem 0',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        display: 'none',
      },
      [theme.breakpoints.down('md')]: {
        right: '3rem',
      },
      '&::before': {
        borderTop: '0.813rem solid transparent',
        borderBottom: '0.813rem solid transparent',
        borderRight:
          selectedTheme === 0
            ? `0.813rem solid ${theme.palette.secondary.main}`
            : `0.813rem solid ${theme.palette.borderColor?.main}`,
        content: '""',
        display: 'none',
        height: '0rem',
        position: 'absolute',
        right: '100%',
        width: '0rem',
        top: '1.3rem',
        [theme.breakpoints.up('md')]: {
          display: 'block',
        },
        [theme.breakpoints.between('sm', 'md')]: {
          display: 'none',
        },
      },
      '&::after': {
        borderTop: '0.813rem solid transparent',
        borderBottom: '0.813rem solid transparent',
        borderRight: `0.813rem solid ${theme.palette.secondary.main}`,
        content: '""',
        display: 'none',
        height: '0rem',
        position: 'absolute',
        right: '-6%',
        width: '0rem',
        top: '1.3rem',
        transform: 'rotate(180deg)',
        [theme.breakpoints.down('md')]: {
          display: 'block',
        },
      },
    },
    List: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.primary.main,
      border: 'none',
      boxShadow: 'none',
      paddingLeft: '0rem',
    },
    arrow: {
      color: theme.palette.primary.main,
    },
    contrastText: {
      color: selectedTheme === 0 ? theme.palette.primary.dark : theme.palette.primary.main,
      fontWeight: 'bolder',
    },
    headerBox: {
      display: 'grid',
      gridTemplateColumns: 'auto max-content',
    },
    lineHeight3: {
      fontSize: '0.875rem',
      paddingLeft: '1rem',
      letterSpacing: '0.05em',
      lineHeight: '163.42%',
      fontWeight: 'bold',
      paddingTop: '1rem',
    },
    listItem: {
      width: '2.151rem',
      height: '2rem',
      fontSize: '1.125rem',
      padding: '0.2rem 0.6rem',
      fontWeight: 'bolder',
      background: theme.palette.background.paper,
      border: `0.125rem solid ${theme.palette.borderColor?.main || BrandColors.transparent}`,
      color: theme.palette.default?.main,
      borderRadius: '0.25rem',
    },
    IEOnlyIcon: {
      '@media screen and (-ms-high-contrast: none)': {
        padding: '0.4rem 0.7rem !important',
      },
    },
    displayNone: {
      display: 'none !important',
    },
    labelIcon: {
      fontSize: '1.125rem',
      fontWeight: 'bold',
      marginLeft: '-0.25rem',
    },
    listItemIcon: {
      minWidth: '2.813rem',
    },
    closeButton: {
      position: 'absolute',
      right: 0,
    },
  });
});
